import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';

import { useEditIncentivesMarketSharePurchaseContractTemplateModal } from '../context/EditIncentivesMarketSharePurchaseContractTemplateModalContext';

const EditIncentivesMarketSharePurchaseContractTemplateModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } =
    useEditIncentivesMarketSharePurchaseContractTemplateModal();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-light"
        onClick={actions.handleCloseModal}
        disabled={data.isSaving}
      >
        {t('Cancel')}
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={actions.handleSave}
        disabled={
          data.isLoading || data.loadError || data.isSaving || !data.documentId
        }
      >
        <em className="icon ni ni-save mr-1" />
        {t('IncentivesMarketContractSaveTemplate')}
      </button>
    </Modal.Footer>
  );
};

export default EditIncentivesMarketSharePurchaseContractTemplateModalFooter;
